import React, { createContext, useContext, useMemo, useState } from "react";

const ModalContext = createContext({
    modalOpen: false,
    openModal: () => {},
    closeModal: () => {},
});

export function ModalProvider({ children }) {
    const [modalOpen, setModalOpen] = useState(false);

    const value = useMemo(() => ({
        modalOpen,
        openModal: () => setModalOpen(true),
        closeModal: () => setModalOpen(false),
    }), [modalOpen]);

    return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
}

export function useModal() {
    return useContext(ModalContext);
}
